var chunkPrefetchChunkToChildrenMap = {"6214":[2623,2623],"3760":[2623,9068,1206],"3833":[2623,9068],"781":[2623,899],"9415":[2623,5448],"1602":[2623],"8832":[2623],"9363":[7463],"976":[2623],"8423":[2623],"3500":[4634,5279,5910],"5910":[2623],"8492":[2623],"8595":[2623,9068]};
__webpack_require__.f.prefetch = (chunkId, promises) => {
  Promise.all(promises).then(() => {
    var chunks = chunkPrefetchChunkToChildrenMap[chunkId];
    Array.isArray(chunks) && chunks.map(__webpack_require__.E);
  });
};
